<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.sms_settings">
  <app-popup-header title="{{localService.languageContent.sms_settings.import_noti}}" [isRefresh]="true"
    (onRefresh)="onLoad()"></app-popup-header>
  <div class="modal-body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}" *ngIf="lessAlert">
    <div *ngIf="lessAlert.lessStockBusiness && lessAlert.lessStockBusiness.length > 0">
      <div class="row">
        <div class="col-12">
          <app-label [Text]="localService.languageContent.sms_settings.less_stock_product_count" [color]="'red'"
            [IsColonRequired]="false" />
        </div>
      </div>
      <div class="box">
        <div class="row styled_row" *ngFor="let item of lessAlert.lessStockBusiness">
          <div class="col-8">
            <app-label [Text]="item.key.toString()" [IsColonRight]="true" />
          </div>
          <div class="col-4">
            <span class="en">{{item.value}}</span>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="lessAlert.messageCredits && lessAlert.messageCredits.length > 0">
      <div class="row">
        <div class="col-12">
          <app-label [Text]="localService.languageContent.sms_settings.running_out_of_credits"></app-label>
        </div>
      </div>
      <div class="row box" *ngFor="let itemGroup of lessAlert.messageCredits">
        <div class="col-12">
          <div [ngClass]="localService.getLanguageCode(itemGroup.key.v1)">
            <app-label [Text]="itemGroup.key.v2"></app-label>
          </div>
          <div>
            <div class="row" *ngFor="let item of itemGroup.values">
              <div class="col-5 label_right" style="text-align:right;">
                <app-label [Text]="localService.getText(lessAlert.notificationTypes,item.v2)"></app-label>
              </div>
              <div class="col-7">
                <span class="en"
                  title="{{localService.languageContent.sms_settings.current_credits}}">{{item.v1}}</span>
              </div>
            </div>
          </div>
          <div>
            <div class="row">
              <div class="col-6" style="text-align:left;">
                <span class="button" style="text-decoration:underline;"
                  (click)="onAction(1,itemGroup.key.key,itemGroup.key.v3)">{{localService.languageContent.sms_settings.add_credits}}</span>
              </div>
              <div class="col-6" style="text-align:right;">
                <span class="button" style="text-decoration:underline;"
                  (click)="onAction(2,itemGroup.key.key,itemGroup.key.v3)">{{localService.languageContent.sms_settings.manage_service}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>